import React from "react";

import { EnhancedIntlContext } from "../../components/EnhancedIntlProvider";

/**
 * Hook to access the EnhancedIntlContext value.
 *
 * @returns The EnhancedIntlContext value.
 * @throws Will throw an error if used outside of a EnhancedIntlContext provider.
 * @example
 * const enhancedIntl = useEnhancedIntl();
 */
function useEnhancedIntl() {
  const enhancedIntl = React.useContext(EnhancedIntlContext);

  if (enhancedIntl === undefined) {
    throw new Error(
      "useEnhancedIntl must be used within an EnhancedIntlContext provider."
    );
  }

  return enhancedIntl;
}

export default useEnhancedIntl;
